import * as React from "react";
import { Grid, GridItem, Text, VStack } from "@chakra-ui/react";
import { COLUMN1, COLUMN2, COLUMN3 } from "./duck";

const Column: React.FC<{ options: string[] }> = ({ options }) => (
  <GridItem as={VStack} spacing="4px" alignItems="flex-start" flex="1">
    {options.map(opt => (
      <Text key={opt} color="gray.900" fontWeight="normal">
        {opt}
      </Text>
    ))}
  </GridItem>
);

const Other: React.FC = () => {
  return (
    <VStack
      w="100%"
      spacing="8px"
      display="inline-flex"
      alignItems="flex-start"
      mt="24px"
    >
      <Text fontWeight="bold" color="gray.600">
        Other
      </Text>
      <Grid gridTemplateColumns="repeat(3, 1fr)" w="100%" gridGap="24px">
        <Column options={COLUMN1} />
        <Column options={COLUMN2} />
        <Column options={COLUMN3} />
      </Grid>
    </VStack>
  );
};

export default Other;
